import { useEffect, useState } from "react";

export const useTabStickyHandler = (ref) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // 카테고리 섹션 아래의 위치를 기준점으로 설정 (약 280px 정도로 예상)
      const stickyThreshold = 280;

      if (window.scrollY > stickyThreshold) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { isSticky };
};
